var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPictureLinear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 3a3 3 0 0 1 3 3v12c0 .065-.002.13-.006.194L21 18a3.039 3.039 0 0 1-.062.611l-.008.035a2.98 2.98 0 0 1-.025.105l.033-.14a2.956 2.956 0 0 1-.084.317l-.008.02-.02.064a3.002 3.002 0 0 1-2.594 1.98c-.002-.002-.004-.002-.006-.002l-.018.003h-.015A3.045 3.045 0 0 1 18 21H6l-.059-.002-.117-.003h-.001L6 21a3.036 3.036 0 0 1-1.16-.233 2.99 2.99 0 0 1-.826-.518A2.993 2.993 0 0 1 3 18V6a3 3 0 0 1 3-3h12zm-4.43 9.68L6 19.5h12l.144-.007A1.5 1.5 0 0 0 19.5 18v-.338l-.5-.502-4.5-4.48a.69.69 0 0 0-.93 0zM18 4.5H6A1.5 1.5 0 0 0 4.5 6v12c0 .246.06.478.164.683l.332-.297 7.563-6.814a2.19 2.19 0 0 1 2.952 0l.047.045 3.942 3.924V6A1.5 1.5 0 0 0 18 4.5zM8.5 7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPictureLinear);
export default __webpack_public_path__ + "static/media/icon-picture-linear.d558db7b.svg";
export { ForwardRef as ReactComponent };